import { render, staticRenderFns } from "./xs.vue?vue&type=template&id=43f15624&scoped=true&"
import script from "./xs.vue?vue&type=script&lang=js&"
export * from "./xs.vue?vue&type=script&lang=js&"
import style0 from "./xs.vue?vue&type=style&index=0&id=43f15624&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f15624",
  null
  
)

export default component.exports